import Cons from '../../isomorphic/cons';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import mobx from 'mobx';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import form from './tcfile-form-component';
import primeHelper from '../utils/prime-helper';
import 'react-datepicker/dist/react-datepicker.css';
import Notifications from '../utils/notification-helper';
import ConfirmModal from '../shared/confirm-modal';
import InvoiceFileModal from './invoice-form-modal';
import LastUpdatedBy from '../components/last-updated-by-component';
import Breadcrumbs from '../components/breadcrumbs-component';
import AgentPreferredEmailModal from '../agents/agent-preferred-email-modal';

@inject('appStore')
@observer
export default class FileForm extends Component {
    constructor(props) {
        super(props);
        this.form = form(this.props.appStore.coordinatorDetailStore.coordinator.roles[0].name);
        this.state = { hasError:false}
    }

    onSave() {
        this.form
            .validate({ showErrors: true })
            .then(form => {
                if (form.isValid) {
                    // this.props.appStore.analytics.track("File Detail Saved", {values: this.form.values(), valid: true})
                    //Time to make sure the data is in the correct format...
                    // TODO: Extract logic into another module/helper
                    let formattedFields = {};
                    _.each(this.form.values(), (value, key) => {
                        if (form.fields.get(key).$extra === 'date') {
                            if (!moment.isMoment(value)) {
                                value = moment(value);
                            }

                            formattedFields[key] = value.isValid() ? value.format() : null;
                        } else {
                            formattedFields[key] = value;
                        }
                    });
                    this.props.appStore.tcFileStore
                        .updateSelected(formattedFields)
                        .then(() => {
                            Notifications.ToastSuccess('File has been saved');
                        })
                        .catch(err => {
                            Notifications.ToastError('Something went wrong saving your file.');
                        });
                } else {
                    const errorMessages = _.filter(form.errors(), (value, key) => {
                        return key !== 'agents' && !_.isUndefined(value);
                    });
                    Notifications.ToastError(errorMessages);
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    updateFieldsFromSelectedViewModel(selectedFileViewModel) {
        _.each(mobx.toJS(selectedFileViewModel), (value, key) => {
            if (this.form.has(key)) {
                if (key === 'agents') {
                    this.form.update({ agents: value });
                } else {
                    this.form.$(key).set(value);
                }
            }
        });
    }

    componentWillMount() {
        this.form.clear();
        this.updateFieldsFromSelectedViewModel(this.props.appStore.tcFileStore.selectedFileViewModel);
        //U G L Y
        const hasPreferredEmail =
            this.props.appStore.tcFileStore.selectedFileViewModel.agents[0].agentProfile &&
            !_.isEmpty(this.props.appStore.tcFileStore.selectedFileViewModel.agents[0].agentProfile.preferredEmail);
        if (this.props.appStore.tcFileStore.selectedFileViewModel.tcFileId === 'new' && !hasPreferredEmail) {
            this.props.appStore.viewStore.preferredEmailDialogOpen = true;
        }
    }

    handleDeleteFile() {
        this.props.appStore.tcFileStore.deleteFile(this.props.appStore.tcFileStore.selectedFile);
        this.props.appStore.viewStore.hideConfirmFileDeleteModal();
    }

    displayDelete() {
        const user = this.props.appStore.coordinatorDetailStore.coordinator;
        return user.hasRole('admin') || user.hasRole('superadmin');
    }

    componentDidMount()
    {

        if(this.props.appStore.tcFileStore.selectedFileViewModel.tcFileId!=="new")
        {
                this.props.appStore.tcFileStore.notExistsInSkyslope()
                .then((data) => {
                    this.setState({hasError : data});
                    if(data == true)
                    {
                        Notifications.ToastInfo("The "+this.form.$(`origin`).value+" does not exist in Skyslope. You will not be able to modify the data.");
                    
                        document.getElementsByName("propertyAddress")[0].setAttribute("disabled", "true");
                        document.getElementsByName("status")[0].setAttribute("disabled", "true");
                        document.getElementsByName("typeOfSale")[0].setAttribute("disabled", "true");
                        document.getElementsByName("propertyType")[0].setAttribute("disabled", "true");
                        
                    }
                })
                    
                .catch(err => {
                    this.setState({hasError : true});
                });
    }
    }
    handleOpenInSkySlopeButtonClick(e) {
        e.preventDefault();
        e.stopPropagation();

        primeHelper.logIntoPropertyFile(this.props.appStore.tcFileStore.selectedFile, appStore.viewStore.selectedTab);
    }

    handlePreferredEmailSave(agentProfile) {
        let agent = _.find(this.props.appStore.tcFileStore.selectedFileViewModel.agents, {
            agentContactId: agentProfile.agentContactId,
        });
        agent.agentProfile = _.clone(agentProfile);
        this.updateFieldsFromSelectedViewModel(this.props.appStore.tcFileStore.selectedFileViewModel);
    }

    render() {                    
        const assignableRoles = [Cons.roles.tc, Cons.roles.admin, Cons.roles.superadmin],
            coordinators = _.chain(this.props.appStore.coordinatorStore.coordinators.values())
                .value()
                .filter(user => assignableRoles.includes(user.roles[0].name)),
            propertyAddress = this.props.appStore.tcFileStore.selectedFile.propertyAddress,
            breadcrumbItems = [{ label: 'Files', href: '#/files' }, { label: propertyAddress }],
            status = this.props.appStore.tcFileStore.selectedFile.status.toString(),
            propertyStatusesAvailableToTc = {
                [`${status.charAt(0).toUpperCase()}${status.slice(1)}`]: status,
                Pending: "pending",
                Active: "active"
            };

        if (
            this.props.appStore.tcFileStore.selectedFile &&
            this.props.appStore.tcFileStore.selectedFile.coordinator['coordinatorId'] &&
            !_.find(coordinators, { coordinatorId: this.props.appStore.tcFileStore.selectedFile.coordinatorId })
        ) {
            coordinators.push(this.props.appStore.tcFileStore.selectedFile.coordinator);
        }

        return (
            <form key={`tcfile-${this.props.appStore.tcFileStore.selectedFile.tcFileId}`}>
                <div className="col-xs-12 col-md-7">
                    <Breadcrumbs items={breadcrumbItems} />
                </div>
                <div className="col-xs-12 col-md-5 form-actions" style={{ marginTop: 0 }}>
                    <button type="button"  disabled={this.state.hasError} className="btn btn-primary pull-right" onClick={this.onSave.bind(this)}>
                        Save
                    </button>
                    <button
                        type="button"
                        className="btn btn-default pull-right"
                        onClick={() => {
                            this.props.appStore.viewStore.openFilesPage();
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-default pull-right"
                        onClick={this.handleOpenInSkySlopeButtonClick.bind(this)}
                        disabled={appStore.tcFileStore.selectedFile.isNew}
                    >
                        Open in SkySlope
                    </button>
                </div>
                <ConfirmModal
                    show={appStore.viewStore.confirmFileDeleteDialogOpen}
                    onHide={appStore.viewStore.hideConfirmFileDeleteModal}
                    onConfirmed={this.handleDeleteFile.bind(this)}
                    headerText={'Delete File'}
                    buttonType={'btn-danger'}
                    bodyText={'Are you sure you want to delete this File?'}
                    buttonText={'Confirm File Delete'}
                />
                <InvoiceFileModal />
                <AgentPreferredEmailModal handlePreferredEmailSave={this.handlePreferredEmailSave.bind(this)} />

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`propertyAddress`).id}>
                            {this.form.$(`propertyAddress`).label}
                        </label>
                      <input className="form-control" {...this.form.$(`propertyAddress`).bind()} />
                        <p className="form-error">{this.form.$(`propertyAddress`).error}</p>
                    </div>
                </div>

                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`status`).id}>{this.form.$(`status`).label}</label>
                        <select className="form-control" {...this.form.$(`status`).bind()}>
                            <option value="">...</option>
                            {this.props.appStore.coordinatorDetailStore.coordinator.hasRole('tc')
                                ? _.map(propertyStatusesAvailableToTc, (value, key) => {
                                        return (
                                            <option key={key} value={value}>
                                                {key}
                                            </option>
                                        );
                                    })
                            
                                : _.map(Cons.fileStatuses, (value, key) => {
                                        return (
                                            <option key={key} value={value}>
                                                {key}
                                            </option>
                                        );
                                    })
                            }
                        </select>
                        <p className="form-error">{this.form.$(`status`).error}</p>
                    </div>
                </div>

                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`subscriberName`).id}>{this.form.$(`subscriberName`).label}</label>
                        <input className="form-control" {...this.form.$(`subscriberName`).bind()} />
                        <p className="form-error">{this.form.$(`subscriberName`).error}</p>
                    </div>
                </div>
                {this.form.has('agents') ? (
                    <div>
                        {this.form.$('agents').map(agent => (
                            <div key={agent.id}>
                                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 ">
                                    <div className="form-group">
                                        <label htmlFor={agent.$(`name`).id}>{agent.$(`name`).label}</label>
                                        <input className="form-control" {...agent.$(`name`).bind()} />
                                        <p className="form-error">{agent.$(`name`).error}</p>
                                    </div>
                                </div>
                                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 ">
                                    <div className="form-group">
                                        <label htmlFor={agent.$(`email`).id}>{agent.$(`email`).label}</label>
                                        <input className="form-control" {...agent.$(`email`).bind()} />
                                        <p className="form-error">{agent.$(`email`).error}</p>
                                    </div>
                                </div>
                                <div className="col-xs-6 no-padding">
                                    <div className="col-xs-12">
                                        <div className="form-group">
                                            <label htmlFor={agent.$(`agentProfile.preferredEmail`).id}>
                                                {agent.$(`agentProfile.preferredEmail`).label}
                                            </label>
                                            <input
                                                className="form-control"
                                                {...agent.$(`agentProfile.preferredEmail`).bind()}
                                            />
                                            <p className="form-error">{agent.$(`agentProfile.preferredEmail`).error}</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-6"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">Missing Agent!</div>
                )}
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`propertyType`).id}>{this.form.$(`propertyType`).label}</label>
                        <select className="form-control" {...this.form.$(`propertyType`).bind()}>
                            <option value="">Select a Type</option>
                            {_.map(Cons.propertyType, (value, key) => {
                                return (
                                    <option key={key} value={value}>
                                        {key}
                                    </option>
                                );
                            })}
                        </select>
                        <p className="form-error">{this.form.$(`propertyType`).error}</p>
                    </div>
                </div>
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`coordinatorId`).id}>Coordinator</label>
                        <select className="form-control" {...this.form.$(`coordinatorId`).bind()}>
                            <option value="">Select a Coordinator</option>
                            {_.map(coordinators, coordinator => {
                                return (
                                    <option
                                        key={coordinator.coordinatorId}
                                        disabled={coordinator.disabled}
                                        value={coordinator.coordinatorId}
                                    >
                                        {coordinator.name}
                                        {coordinator.disabled ? ' - Disabled' : ''}
                                    </option>
                                );
                            })}
                        </select>
                        <p className="form-error">{this.form.$(`coordinatorId`).error}</p>
                    </div>
                </div>

                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`typeOfSale`).id}>{this.form.$(`typeOfSale`).label}</label>
                        <select className="form-control" {...this.form.$(`typeOfSale`).bind()}>
                            <option value="">Select a Type</option>
                            {_.map(Cons.saleTypes, (value, key) => {
                                return (
                                    <option key={key} value={value}>
                                        {key}
                                    </option>
                                );
                            })}
                        </select>
                        <p className="form-error">{this.form.$(`typeOfSale`).error}</p>
                    </div>
                </div>

                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`origin`).id}>{this.form.$(`origin`).label}</label>
                        <input className="form-control" {...this.form.$(`origin`).bind()} />
                        <p className="form-error">{this.form.$(`origin`).error}</p>
                    </div>
                </div>

                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 date-control">
                    <div className="form-group">
                        <label htmlFor={this.form.$('fileSubmissionDate').id} style={{ display: 'block' }}>
                            {this.form.$('fileSubmissionDate').label}
                        </label>
                        <DatePicker
                            fixedHeight                            
                            className="form-control"
                            style={{ display: 'inline-block' }}
                            dateFormat="L"
                            id={this.form.$('fileSubmissionDate').id}
                            selected={
                                this.form.$('fileSubmissionDate').value
                                    ? moment(this.form.$('fileSubmissionDate').value)
                                    : null
                            }
                            onChange={this.form.$('fileSubmissionDate').sync}
                            disabled={this.form.$('fileSubmissionDate').disabled || false}
                        />
                    </div>
                    <p className="form-error">{this.form.$(`fileSubmissionDate`).error}</p>
                </div>
                {
                    this.form.$(`origin`).value !== 'Transaction' &&
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 date-control">
                        <div className="form-group">
                            <label htmlFor={this.form.$('expirationDate').id} style={{ display: 'block' }}>
                                {this.form.$('expirationDate').label}
                            </label>
                            <DatePicker      
                                fixedHeight
                                className="form-control"
                                style={{ display: 'inline-block' }}
                                dateFormat="L"
                                id={this.form.$('expirationDate').id}
                                selected={
                                    this.form.$('expirationDate').value ? moment(this.form.$('expirationDate').value) : null
                                }
                                onChange={this.form.$('expirationDate').sync}
                                disabled={this.form.$('expirationDate').disabled || false}
                            />
                        </div>
                    <p className="form-error">{this.form.$(`expirationDate`).error}</p> 
                    </div>
                }
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 checkbox-group">
                    <div className="form-group">
                        <div className="checkbox">
                            <label>
                                <input disabled={appStore.tcFileStore.hasErrors} type="checkbox" {...this.form.$(`survey`).bind()} />
                                Survey
                            </label>
                        </div>
                        <p className="form-error">{this.form.$(`survey`).error}</p>
                    </div>

                    <div className="form-group">
                        <div className="checkbox">
                            <label>
                                <input disabled={appStore.tcFileStore.hasErrors} type="checkbox" {...this.form.$(`hud`).bind()} />
                                HUD
                            </label>
                        </div>
                        <p className="form-error">{this.form.$(`hud`).error}</p>
                    </div>

                    <div className="form-group">
                        <div className="checkbox">
                            <label>
                                <input disabled={appStore.tcFileStore.hasErrors} type="checkbox" {...this.form.$(`thumbDrive`).bind()} />
                                Thumb Drive
                            </label>
                        </div>
                        <p className="form-error">{this.form.$(`thumbDrive`).error}</p>
                    </div>
                </div>
                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 date-control">
                    <div className="form-group">
                        <label htmlFor={this.form.$('estimatedCloseDate').id} style={{ display: 'block' }}>
                            {this.form.$('estimatedCloseDate').label}
                        </label>
                        <DatePicker
                            fixedHeight                            
                            className="form-control"
                            style={{ display: 'inline-block' }}
                            dateFormat="L"
                            id={this.form.$('estimatedCloseDate').id}
                            selected={
                                this.form.$('estimatedCloseDate').value
                                    ? moment(this.form.$('estimatedCloseDate').value)
                                    : null
                            }
                            onChange={this.form.$('estimatedCloseDate').sync}
                            disabled={this.form.$('estimatedCloseDate').disabled ||appStore.tcFileStore.hasErrors || false}
                        />
                    </div>
                    <p className="form-error">{this.form.$(`estimatedCloseDate`).error}</p>
                </div>
                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 date-control">
                    <div className="form-group">
                        <label htmlFor={this.form.$('actualCloseDate').id} style={{ display: 'block' }}>
                            {this.form.$('actualCloseDate').label}
                        </label>
                        <DatePicker
                            fixedHeight                            
                            className="form-control"
                            style={{ display: 'inline-block' }}
                            dateFormat="L"
                            id={this.form.$('actualCloseDate').id}
                            selected={
                                this.form.$('actualCloseDate').value
                                    ? moment(this.form.$('actualCloseDate').value)
                                    : null
                            }
                            onChange={this.form.$('actualCloseDate').sync}
                            disabled={this.form.$('actualCloseDate').disabled ||appStore.tcFileStore.hasErrors ||false}
                        />
                    </div>
                    <p className="form-error">{this.form.$(`actualCloseDate`).error}</p>
                </div>

                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`daysInEscrow`).id}>{this.form.$(`daysInEscrow`).label}</label>
                        <input className="form-control" {...this.form.$(`daysInEscrow`).bind()} />
                        <p className="form-error">{this.form.$(`daysInEscrow`).error}</p>
                    </div>
                </div>

                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`checkStatus`).id}>{this.form.$(`checkStatus`).label}</label>
                        <select className="form-control" {...this.form.$(`checkStatus`).bind()}>
                            <option value="-1">...</option>
                            {_.map(Cons.checkStatuses, (value, key) => {
                                return (
                                    <option key={key} value={value}>
                                        {key}
                                    </option>
                                );
                            })}
                        </select>
                        <p className="form-error">{this.form.$(`checkStatus`).error}</p>
                    </div>
                </div>

                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`checkAmount`).id}>{this.form.$(`checkAmount`).label}</label>
                        <input className="form-control" {...this.form.$(`checkAmount`).bind()} />
                        <p className="form-error">{this.form.$(`checkAmount`).error}</p>
                    </div>
                </div>

                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 ">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`checkNumber`).id}>{this.form.$(`checkNumber`).label}</label>
                        <input className="form-control" {...this.form.$(`checkNumber`).bind()} />
                        <p className="form-error">{this.form.$(`checkNumber`).error}</p>
                    </div>
                </div>

                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 date-control">
                    <div className="form-group">
                        <label htmlFor={this.form.$('depositDate').id} style={{ display: 'block' }}>
                            {this.form.$('depositDate').label}
                        </label>
                        <DatePicker
                            fixedHeight                            
                            className="form-control"
                            style={{ display: 'inline-block' }}
                            dateFormat="L"
                            id={this.form.$('depositDate').id}
                            selected={
                                this.form.$('depositDate').value ? moment(this.form.$('depositDate').value) : null
                            }
                            onChange={this.form.$('depositDate').sync}
                            disabled={this.form.$('depositDate').disabled || false}
                        />
                    </div>
                    <p className="form-error">{this.form.$(`actualCloseDate`).error}</p>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                    <div className="form-group">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`title`).id}>{this.form.$(`title`).label}</label>
                            <input className="form-control" {...this.form.$(`title`).bind()} />
                            <p className="form-error">{this.form.$(`title`).error}</p>
                        </div>
                    </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                    <div className="form-group">
                        <label htmlFor="notes">Notes</label>
                        <textarea
                            className="form-control"
                            id="notes"
                            {...this.form.$(`notes`).bind()}
                            rows="4"
                            cols="50"
                            disabled={appStore.tcFileStore.hasErrors}
                        />
                    </div>
                </div>

                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5  form-actions">
                    {// TODO permission this
                    this.displayDelete() ? (
                        <button
                            type="button"
                            className="btn btn-default"
                            disabled={appStore.tcFileStore.selectedFile.isNew}
                            onClick={appStore.viewStore.showConfirmFileDeleteModal}
                        >
                            Delete File
                        </button>
                    ) : null}

                </div>
                <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7 form-actions">
                    <button type="button" disabled={appStore.tcFileStore.hasErrors} className="btn btn-primary pull-right" onClick={this.onSave.bind(this)}>
                        Save
                    </button>
                    <button
                        type="button"
                        className="btn btn-default pull-right"
                        onClick={() => {
                            // this.props.appStore.analytics.track("File Detail Canceled", {})
                            this.props.appStore.viewStore.openFilesPage();
                        }}
                    >
                        Cancel
                    </button>
                    <p className="form-error">{this.form.error}</p>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <LastUpdatedBy
                        model={this.props.appStore.tcFileStore.selectedFile}
                        coordinators={this.props.appStore.coordinatorStore.coordinators}
                    />
                </div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/files/tcfile-form-view.js